import * as apiGetUser from "@/api/vp/users/getUser";

import _ from "lodash";
import Vue from "vue";

export default {
  namespaced: true,
  state: {
    loading: false,
    isAuthenticated: false,
    userId: "",
    users: {},
    userInfo: {}
  },
  mutations: {
    gotUser(state, payload) {
      Vue.set(state.users, payload.userId, payload.result);
    },
    gotUserInfo(state,payload){
      state.userInfo = payload
    },

    isLoading(state, loading) {
      state.loading = loading;
    },
    setAuthenticated(state, isAuthenticated) {
      state.isAuthenticated = isAuthenticated;
    },
    setUserId(state, userId) {
      state.userId = userId;
    }
  },
  actions: {
    async ensureMe({ commit, dispatch, getters }) {
      commit("isLoading", true);

      if (!getters.me) {
        await dispatch("getUser", getters.userId);
      }

      commit("isLoading", false);
    },

    async getUser({ commit }, userId) {
      commit("isLoading", true);

      const result = await apiGetUser.get(userId);

      const payload = {
        userId,
        result
      };

      if (result) {
        commit("gotUser", payload);
      }

      commit("isLoading", false);
    },


    async setAuthenticated({ commit, dispatch }, isAuthenticated) {
      commit("setAuthenticated", isAuthenticated);
    },

    async setUserId({ commit, dispatch }, userId) {
      commit("setUserId", userId);
    }
  },
  getters: {
    userInfo: state =>{
      return state.userInfo
    },
    isAuthenticated: state => {
      return state.isAuthenticated;
    },

    user: state => userId => {
      return state.users[userId];
    },
    me: state => {
      return state.users[state.userId];
    },
    userId: state => {
      return state.userId;
    },
    preferredRole: state => {
      const usr = state.users[state.userId];
      if (usr) {
        const levelTags = usr.tags.filter(e => e.includes("level:")).map(e => e.split(":")[1])
        return levelTags.length > 0 ? levelTags[0] : null;
      }
      return null
      /*if (usr && usr.tags.includes("level:vm")) return "vm"
      else if (usr.tags.includes("level:sm")) return "sm"
      else return null;*/
    },
    isCM: state => {
      const usr = state.users[state.userId];
      return usr && usr.tags.includes("level:cm");
    },
    isRM: state => {
      const usr = state.users[state.userId];
      return usr && usr.tags.includes("level:rm");
    },
    isHQ: state => {
      const usr = state.users[state.userId];

      const hqTags = ["hq", "hqdk"];
      return usr && usr.tags.some(tag => hqTags.includes(tag));
    }
  }
};
